module.exports = "<xo-link content label=\"{{ content('common.showMoreFi') }}\" on-click=\"actions.showMore\" left-icon=\"caret-down\"></xo-link>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/show-more-fi/template.html
// module id = ../node_modules/xo-member-components/src/show-more-fi/template.html
// module chunks = 0